import config from 'config'
import { createAxiosInstance } from 'api/axiosFactory'

export const fetchDeveloperToken = (accessToken) =>
  createAxiosInstance().post(`${config.LOGIN_API_URL}?access_token=${accessToken}`)
    .then(response => response.data.token)
